import { render, staticRenderFns } from "./BuyoutBatchItemJewelList.vue?vue&type=template&id=4c1350df"
import script from "./BuyoutBatchItemJewelList.vue?vue&type=script&lang=js"
export * from "./BuyoutBatchItemJewelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports